import $http, { handleError } from '@/plugins/axios'
import { extractChapterException } from '@/utils/helpers'

const RESOURCE_NAME = '/admin/promotions'

export default {
  getAllPaged (params) {
    return $http().get(`${RESOURCE_NAME}/paged`, {
      params: params
    })
  },
  getAll (params) {
    return $http().get(RESOURCE_NAME, {
      params: params
    })
  },
  get (id) {
    return $http().get(`${RESOURCE_NAME}/${id}`)
  },

  create (promotion) {
    return $http().post(RESOURCE_NAME, this.getFormData(promotion), { handleError: false })
      .catch(e => {
        const chapterException = extractChapterException(e)
        if (!chapterException || !chapterException.isPromotionException) {
          handleError(e)
        }
        throw e
      })
  },

  update (promotion) {
    return $http().put(`${RESOURCE_NAME}/${promotion.id}`, this.getFormData(promotion), { handleError: false })
      .catch(e => {
        const chapterException = extractChapterException(e)
        if (!chapterException || !chapterException.isPromotionException) {
          handleError(e)
        }
        throw e
      })
  },

  getFormData (promotion) {
    let formData = new FormData()
    for (var key in promotion) {
      if (promotion[key]) {
        let childKey = null
        if (key === 'applicableProductList') {
          for (childKey in promotion[key]) {
            if (childKey === 'productListMaps') {
              for (let index = 0; index < promotion[key][childKey].length; index++) {
                formData.append(`applicableProductList.${childKey}[${index}].productId`, promotion[key][childKey][index].productId)
                formData.append(`applicableProductList.${childKey}[${index}].overridePrice`, promotion[key][childKey][index].overridePrice)
              }
            } else {
              formData.append(`applicableProductList.${childKey}`, promotion[key][childKey])
            }
          }
        } else if (key === 'requiredProductList') {
          for (childKey in promotion[key]) {
            formData.append(`requiredProductList.${childKey}`, promotion[key][childKey])
          }
        } else if (key === 'applicableProducts' && promotion['applicableProducts']) {
          const products = promotion[key]
          for (let index = 0; index < products.length; index++) {
            for (childKey in products[index]) {
              if (products[index][childKey]) {
                formData.append(`applicableProducts[${index}].${childKey}`, products[index][childKey])
              }
            }
          }
        } else if (key === 'requiredProducts' && promotion['requiredProducts']) {
          const products = promotion[key]
          for (let index = 0; index < products.length; index++) {
            for (childKey in products[index]) {
              if (products[index][childKey]) {
                formData.append(`requiredProducts[${index}].${childKey}`, products[index][childKey])
              }
            }
          }
        } else if (key === 'applicableCategoryIds' && promotion['applicableCategoryIds']) {
          const categoryIds = promotion[key]
          for (let index = 0; index < categoryIds.length; index++) {
            formData.append(`applicableCategoryIds[${index}]`, categoryIds[index])
          }
        } else if (key === 'requiredCategoryIds' && promotion['requiredCategoryIds']) {
          const categoryIds = promotion[key]
          for (let index = 0; index < categoryIds.length; index++) {
            formData.append(`requiredCategoryIds[${index}]`, categoryIds[index])
          }
        } else if (key === 'applicableImprintIds' && promotion['applicableImprintIds']) {
          const imprintIds = promotion[key]
          for (let index = 0; index < imprintIds.length; index++) {
            formData.append(`applicableImprintIds[${index}]`, imprintIds[index])
          }
        } else if (key === 'customerRoleIds' && promotion['customerRoleIds']) {
          const customerRoleIds = promotion[key]
          for (let index = 0; index < customerRoleIds.length; index++) {
            console.log(customerRoleIds[index])
            formData.append(`customerRoleIds[${index}]`, customerRoleIds[index])
          }
        } else if (key === 'requiredImprintIds' && promotion['requiredImprintIds']) {
          const imprintIds = promotion[key]
          for (let index = 0; index < imprintIds.length; index++) {
            formData.append(`requiredImprintIds[${index}]`, imprintIds[index])
          }
        } else if (key === 'promotionToPromotionExclusionType' && promotion['promotionToPromotionExclusionType']) {
          const promotionToPromotionExclusionType = promotion[key]
          formData.append(`promotionToPromotionExclusionType.value`, promotionToPromotionExclusionType['value'])
          formData.append(`promotionToPromotionExclusionType.promotionExclusionTypeId`, promotionToPromotionExclusionType['promotionExclusionTypeId'])
          formData.append(`promotionToPromotionExclusionType.startDateValue`, promotionToPromotionExclusionType['startDateValue'])
          formData.append(`promotionToPromotionExclusionType.endDateValue`, promotionToPromotionExclusionType['endDateValue'])
        } else if (key === 'bundle') {
          const bundle = promotion[key]
          for (childKey in bundle) {
            if (childKey === 'itemsNotForIndividualSale') {
              var itemsNotForIndividualSale = bundle[childKey]
              for (let index = 0; index < itemsNotForIndividualSale.length; index++) {
                formData.append(`bundle.${childKey}[${index}]`, itemsNotForIndividualSale[index])
              }
            } else {
              formData.append(`bundle.${childKey}`, bundle[childKey])
            }
          }
        } else {
          formData.append(key, promotion[key])
        }
      }
    }
    return formData
  }
}
